import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaInstagram, FaYoutube, FaArrowRight, FaWhatsapp, FaGoogle } from 'react-icons/fa';
import '../styles/footer.css'; // Custom styles
import logo from '../images/channelicon2.png'; // Replace with your logo
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-custom my-5 py-5">
      <Container fluid>
        <Row className="gy-4 justify-content-center">
          {/* Logo and Tagline */}
          <Col xs={12} md={6} lg={3} className="text-center text-md-start">
            <div className="footer-logo">
              <img src={logo} alt="Olewin Academy Logo" className="img-fluid mb-3" />
              <p className="footer-tagline fw-bold">
                Empowering learners globally with quality education and training content for a new approach to learning paradigms.
              </p>
            </div>
          </Col>

          {/* Training Path Links */}
          <Col xs={12} md={6} lg={2} className="text-center text-md-start">
            <h5 className="footer-heading">Our Training Path</h5>
            <hr className="text-light" />
            <ul className="footer-links" style={{ fontSize: '0.9rem' }}>
              <li className="p-1">
                <a href="/beginner-courses">
                  <FaArrowRight className="me-2" /> Beginner Courses
                </a>
              </li>
              <li className="p-1">
                <a href="/advance-courses">
                  <FaArrowRight className="me-2" /> Advanced Courses
                </a>
              </li>
              <li className="p-1">
                <a href="/certifications">
                  <FaArrowRight className="me-2" /> Certifications
                </a>
              </li>
                   <li className="p-1">
                <a href="/certification-courses">
                  <FaArrowRight className="me-2" /> Certification Courses
                </a>
              </li>
              <li className="p-1">
                <a href="/company-internships">
                  <FaArrowRight className="me-2" /> Paid Internships
                </a>
              </li>
              <li className="p-1">
                <a href="/online-training">
                  <FaArrowRight className="me-2" /> Online Training
                </a>
              </li>
            </ul>
          </Col>

          {/* Services Links */}
          <Col xs={12} md={6} lg={2} className="text-center text-md-start">
            <h5 className="footer-heading">Explore Courses</h5>
            <hr className="text-light" />
            <ul className="footer-links" style={{ fontSize: '0.9rem' }}>
              <li className="p-1">
                <a href="/personal-coaching">
                  <FaArrowRight className="me-2" /> Personal Coaching
                </a>
              </li>
              <li className="p-1">
                <a href="/group-coaching">
                  <FaArrowRight className="me-2" /> Group Training
                </a>
              </li>
              <li className="p-1">
                <a href="/mentorship">
                  <FaArrowRight className="me-2" /> Mentorship
                </a>
              </li>
              <li className="p-1">
                <a href="/learning-path">
                  <FaArrowRight className="me-2" /> Learning Path Guidance
                </a>
              </li>
              <li className="p-1">
                <a href="/content-creation">
                  <FaArrowRight className="me-2" /> Content Creation
                </a>
              </li>
            </ul>
          </Col>

          {/* More Links */}
          <Col xs={12} md={6} lg={2} className="text-center text-md-start">
            <h5 className="footer-heading">More</h5>
            <hr className="text-light" />
            <ul className="footer-links" style={{ fontSize: '0.9rem' }}>
              <li className="p-1">
                <a href="/about">
                  <FaArrowRight className="me-2" /> About Us
                </a>
              </li>
              <li className="p-1">
                <a href="/contact">
                  <FaArrowRight className="me-2" /> Contact Us
                </a>
              </li>
              <li className="p-1">
                <a href="/faqs">
                  <FaArrowRight className="me-2" /> FAQs
                </a>
              </li>
              <li className="p-1">
                <a href="/terms-of-services">
                  <FaArrowRight className="me-2" /> Terms of Service
                </a>
              </li>
              <li className="p-1">
                <a href="/privacy">
                  <FaArrowRight className="me-2" /> Privacy Policy
                </a>
              </li>
            </ul>
          </Col>

          {/* Social Links */}
          <Col xs={12} md={6} lg={2} className="text-center">
            <h5 className="footer-heading">Follow & Connect With Us</h5>
            <hr className="text-light" />
            <div className="footer-social-icons d-flex justify-content-center gap-3" style={{ fontSize: '1.5rem' }}>
              <a 
                href="https://www.youtube.com/@olewinacademy" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="text-decoration-none"
              >
                <FaYoutube />
              </a>
              <a 
                href="https://www.instagram.com/olewin_academy/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-decoration-none"
              >
                <FaInstagram />
              </a>
              <a 
                href="https://wa.me/8639449423" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="text-decoration-none"
              >
                <FaWhatsapp />
              </a>
              <a 
                href="mailto:olewinacademy@gmail.com?subject=Inquiry&body=Hello%20Olewin%20Academy%20Team," 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Email"
                className="text-decoration-none"
              >
                <FaGoogle />
              </a>
            </div>
          </Col>
        </Row>

        {/* Footer Bottom */}
        <div className="footer-container text-info text-center mt-1">
          <p className="fw-bold mb-2">Designed & Developed By OlewinTechSolutions</p>
          <p className="mb-2">Copyright &copy; {new Date().getFullYear()} Olewin Academy.</p>
          <p className="love-india mb-3">Made with ❤️ in India</p>

          <div className="footer-links mb-2">
           <Link to="/google-reviews" className='btn btn-success text-white fw-bold rounded-5 border-1 px-5 py-3 m-3 '> Google Reviews </Link>
            
            <a href="/feedback" className="text-decoration-none me-2">Feedback</a> |
            <a href="/cookies-preferences" className="text-decoration-none mx-2">Cookies Preferences </a> |
            <a href="/mentorship" className="text-decoration-none mx-2">Meet the Team</a> |
            <a href="/careers" className="text-decoration-none ms-2">Careers</a> |
            <a href="/jobs" className=" btn btn-warning m-2  fw-bold fs-6 text-dark border-3 rounded-5 text-decoration-none ms-2  ">Open Positions</a>
            <a href="/full-time-jobs" className=" btn btn-info m-2 fw-bold text-white border-3 rounded-5 text-decoration-none ms-2">Full Time Roles</a>
          </div>
        </div>

        <hr className="my-0" style={{ borderColor: '#ffffffff' }} />

        <Row>
          <Col className="text-center">
            <p className="mb-0" style={{ fontSize: '0.9rem' }}>
              &copy; {new Date().getFullYear()} All rights Reserved.
            </p>
               <p className="mb-3 mt-3" style={{ fontSize: '0.9rem' }}>
              A Product & Service from Olewin Group.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;